module.exports = __webpack_public_path__ + "static/CI-Journeys3-f77dd60068dee692b5f9f79b890d0dd5.jpg";